import { GenericRule } from '../../../../../../../utils/genericValidator.util';
import { getOfflineProductColorPacksBasedOnAvailability } from '../../../../../database/offlineDatabase/types/offlineDatabaseProductColor.types';
import { OfflineOrderProduct } from '../../OfflineOrderProduct';

export class ValidateProductColorPackIntegrityRule implements GenericRule<OfflineOrderProduct> {
  validateOrThrow(orderProduct: OfflineOrderProduct) {
    const allAppliedPacks = orderProduct.packs;

    const allProductColorPacks = getOfflineProductColorPacksBasedOnAvailability(
      orderProduct.productColor,
      orderProduct.availability,
    );

    if (!allAppliedPacks) {
      if (allProductColorPacks.length) {
        throw new Error('product color pack integrity is invalid');
      }

      return;
    }

    const allPacksAreValid = allAppliedPacks.every((appliedPack) => {
      return allProductColorPacks.some((productColorPack) => {
        const appliedPackId = appliedPack.pack.id;
        const productColorPackId = productColorPack.packId;

        return appliedPackId === productColorPackId;
      });
    });

    if (!allPacksAreValid) {
      throw new Error('product color pack integrity is invalid');
    }
  }
}
